url_protocol = 'http';

if(location.protocol=='https:')
{
	url_protocol = 'https';
}

var IS_LIVE = true;
var urlArray = window.location.pathname.split("/");	
if(typeof urlArray[1] !== 'undefined' && urlArray[1] == 'symphony') {
	var SITE_ROOT = url_protocol+'://'+document.domain+'/symphony/';
} else {
	var SITE_ROOT = url_protocol+'://'+document.domain+'/';
}
var FRONTEND_ROOT = url_protocol+'://'+document.domain+'/';
var ROOT_PATH = '/';

//clears and replaces text in form input fields and textareas
function clearText(thefield,defaultValue) {
	if(defaultValue=='') { defaultValue = thefield.defaultValue; }
	if (defaultValue==thefield.value) { thefield.value = ""; }
}
function replaceText(thefield,defaultValue) {
	if(defaultValue=='') { defaultValue = thefield.defaultValue; }
	if (thefield.value=="") { thefield.value = defaultValue; }
}

function getQueryVariable(variable) {
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for (var i=0;i<vars.length;i++) {
		var pair = vars[i].split("=");
		if (pair[0] == variable) {
			return pair[1];
		}
	}
}

function getPageName()
{
    return location.pathname.substring(1);
}

function getQueryString(key)
{
    var re = new RegExp( "[?&]" + key + "=([^&$]*)", "i" );
    var offset = location.search.search( re );
    if ( offset == -1 ) return null;
    return RegExp.$1;
}

function submitOnEnter(myfield,e)
{
	var keycode;
	if (window.event) keycode = window.event.keyCode;
	else if (e) keycode = e.which;
	else return true;

	if (keycode == 13)
	{
		myfield.form.submit();
		return false;
	}
	else
	return true;
}

function submitenter(myfield,submitFunction,e)
{
	var keycode;
	if (window.event) keycode = window.event.keyCode;
	else if (e) keycode = e.which;
	else return true;

	if (keycode == 13)
	{
		if(submitFunction=="submit")
		{
			myfield.form.submit();
		}
		else
		{
			eval(submitFunction)();
		}
		return false;
	}
	else return true;
}


function confirmDeleteStandard(delUrl,itemid,title,deleteType,callback) {
	if (confirm("Are you sure you want to delete the "+deleteType+" : "+title+"?")) {
		$.post(SITE_ROOT+delUrl,
			{
				operation: 'deleteItem',
				id: itemid
			},
			function(data){
				eval(callback)();
			},
			"json"
		);
	}
}

function confirmDelete(delUrl,itemid,title,deleteType) {
	if (confirm("Are you sure you want to delete the "+deleteType+" : "+title+"?")) {
		$.post(SITE_ROOT+delUrl,
			{
				operation: 'deleteItem',
				id: itemid
			},
			function(data){
				try {
                    gridReload();
                }catch(error) {
                    console.error(error);
                    location.reload();
                }
			},
			"json"
		);
	}
}

function confirmDeleteMultiple(delUrl,items,deleteType) {
	if (confirm("Are you sure you want to delete the selected "+deleteType+"(s)?")) {
		$.post(SITE_ROOT+delUrl,
			{
				operation: 'deleteItem',
				id: items
			},
			function(data){
				gridReload();
			},
			"json"
		);
	}
}

function slideDown_prep(el){
	var $el = $(el), height = $el.data("originalHeight"), visible = $el.is(":visible");

	if( !height ){
		height = $el.show().height();
		// update the height
		$el.data("originalHeight", height);
		// if the element was hidden, hide it again
		if( !visible ) $el.hide().css({height: 0});
	}
}

function explode (delimiter, string, limit) {
    // Splits a string on string separator and return array of components. If limit is positive only limit number of components is returned. If limit is negative all components except the last abs(limit) are returned.
    //
    // version: 1003.2411
    // discuss at: http://phpjs.org/functions/explode    // +     original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +     improved by: kenneth
    // +     improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +     improved by: d3x
    // +     bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)    // *     example 1: explode(' ', 'Kevin van Zonneveld');
    // *     returns 1: {0: 'Kevin', 1: 'van', 2: 'Zonneveld'}
    // *     example 2: explode('=', 'a=bc=d', 2);
    // *     returns 2: ['a', 'bc=d']
     var emptyArray = { 0: '' };

    // third argument is not required
    if ( arguments.length < 2 ||
        typeof arguments[0] == 'undefined' ||        typeof arguments[1] == 'undefined' ) {
        return null;
    }

    if ( delimiter === '' ||        delimiter === false ||
        delimiter === null ) {
        return false;
    }
     if ( typeof delimiter == 'function' ||
        typeof delimiter == 'object' ||
        typeof string == 'function' ||
        typeof string == 'object' ) {
        return emptyArray;    }

    if ( delimiter === true ) {
        delimiter = '1';
    }
    if (!limit) {
        return string.toString().split(delimiter.toString());
    } else {
        // support for limit argument        var splitted = string.toString().split(delimiter.toString());
        var partA = splitted.splice(0, limit - 1);
        var partB = splitted.join(delimiter.toString());
        partA.push(partB);
        return partA;    }
}

function in_array (needle, haystack, argStrict) {
    // Checks if the given value exists in the array
    //
    // version: 1003.2411
    // discuss at: http://phpjs.org/functions/in_array    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   improved by: vlado houba
    // +   input by: Billy
    // +   bugfixed by: Brett Zamir (http://brett-zamir.me)
    // *     example 1: in_array('van', ['Kevin', 'van', 'Zonneveld']);    // *     returns 1: true
    // *     example 2: in_array('vlado', {0: 'Kevin', vlado: 'van', 1: 'Zonneveld'});
    // *     returns 2: false
    // *     example 3: in_array(1, ['1', '2', '3']);
    // *     returns 3: true    // *     example 3: in_array(1, ['1', '2', '3'], false);
    // *     returns 3: true
    // *     example 4: in_array(1, ['1', '2', '3'], true);
    // *     returns 4: false
    var key = '', strict = !!argStrict;
    if (strict) {
        for (key in haystack) {
            if (haystack[key] === needle) {
                return true;            }
        }
    } else {
        for (key in haystack) {
            if (haystack[key] == needle) {                return true;
            }
        }
    }
     return false;
}

function in_str (haystack, needle) { //equivalent of the php strpos
	//alert('looking for "'+needle+'" in "'+haystack+'"');

	if ( haystack.indexOf( needle ) > -1 ) {
	  return true;
	} else {
	  return false;
	}
}

function setUpUnload()
{
	window.onbeforeunload = function() {
		return ''; //insert custom message here.
	};
}

function show_must_login(){
    $("#mustlogin").show("fast");
}


function formProcessSetup(formId)
{
	$('#'+formId+' .errorMsg').slideUp();
	$('#'+formId+' .errorMsg').html('');

    if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').show();
}

//-------------rework the show error function + helpers for more flexibility------------------//
function showResult(data, formId, extras)
{
	/*extras parameters:
		dont_reset_form = if set will not reset the form
		dont_hide_form = if set will not hide the form
		skip_parent_errors = if set errors will not be placed on the parent elements
		step_content = if set will load up the content  into div
		page_redirect = if set will redirect to the page passed on success
		function_name = if set will call function on form submit success
		use_exact_path = if set will use exact path passed instead of a SITE_ROOT path
		exact_path = path to use for the above option
		dont_scroll_on_error = if set will not scroll to top of page when theres an error
		dont_scroll_on_success = if set will not scroll to top on success
		scrollto = element id to scroll to instead
		clear_errors = if set will clear errors on the form
		dont_hide_buttons = if set will not hide the buttons, use for nested forms.
	*/
	
	if(extras == undefined) { extras = '' } //check if the extras parameters array exists if not set it so that we dont get errors farther down

	$('#'+formId+' .errorMsg').slideUp();
	$('#'+formId+' .errorMsg').html('');

	if(extras.dont_hide_buttons != '1')
	{
    	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').show();
  	}

  	//check if result is being passed the new way
	var result; //will hold the value for our result success | error

	if(data[0]==undefined) result = data.result;
	else result = data[0].result;

	

  	if(result=="success")
	{
  		if(extras.dont_reset_form != '1') { resetForm(formId); } //if the dont_reset_form is isnt set then reset the form
		if(extras.step_content != undefined) //check if the ajax page parameter is defined
		{
			//alert('load up via ajax: ' + data[1].step_content);
		   	$("#step_content").hide();	//this has to stay the same because this is where the forms are being loaded into
	   		$("#step_content").load(SITE_ROOT+extras.step_content,function(){

	        	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
	        	$("#step_content").slideDown();}
	        );
	   		if(extras.dont_scroll_on_success != '1')
	        {
		   		if(extras.scrollto != undefined)
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
		        	} else {
		        		$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
		        	}
		   		}
		   		else
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo(0,100);
		        	} else {
		        		//$.scrollTo(0,800);
		        	}
		   		}
	        }
		}
		else if(extras.page_redirect != undefined) //check if page redirect parameter is passed
		{
			if(extras.use_exact_path =='1')
			{
				window.location = extras.exact_path;
			}
			else
			{
				window.location=SITE_ROOT+extras.page_redirect;
			}
		}
		else if(extras.function_name != undefined)
		{
			eval(extras.function_name)();
		}
		else
		{
			if($('.thankyouMsg').length > 0) $('#'+formId+' .thankyouMsg').slideDown();
			if($('#'+formId).prev(".thankyouMsg").length > 0) $('#'+formId).prev(".thankyouMsg").slideDown();

			if(extras.dont_hide_form != '1')
			{
				if($('#'+formId).length > 0) $("#"+formId).slideUp();
			}
			else
			{
	        	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
			}
			if(extras.dont_scroll_on_success != '1')
	        {
				if(extras.scrollto != undefined)
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
		        	} else {
		        		$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
		        	}
		   		}
		   		else
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo(0,100);
		        	} else {
		        		//$.scrollTo(0,800);
		        	}
		   		}
			}
		}
		if(extras.clear_errors == '1')
		{ 	clearErrors(formId);	}
	}
	else
	{
		showErrors(data,formId,extras);
	}
}

function showErrors(data,formId,extras)
{
	clearErrors(formId);

	var newData = new Object();
	if(data[0]==undefined) newData = data;
	else newData = data[0];
	//loop through the JSON array and display the errors
	$.each(newData, function(key,value) {
		if(key != "result")
		{
			if(extras.add_parent_error != undefined)
			{
				if($('#'+key).parent().hasClass("form-entry")) $('#'+key).parent().addClass("error");
			}
			$('label[for='+key+']').addClass("error");
			$('#'+key).addClass("error");
			
			if(value!=1) {
				if(key=="dataFa")
					$("#"+formId+" .errorMsg").html($("#"+formId+" .errorMsg").html()+"<li class='successMsg'>"+value+"</li>"); 
				else
					$("#"+formId+" .errorMsg").html($("#"+formId+" .errorMsg").html()+"<li>"+value+"</li>"); 
			}
		}
	});
	if($("#"+formId+" .errorMsg").html()=="") {
		$("#"+formId+" .errorMsg").html("<ul><li>Please correct the errors highlighted in red below</li></ul>");
	} else {
		$("#"+formId+" .errorMsg").html("<ul>"+$("#"+formId+" .errorMsg").html()+"</ul>");
	}
	$("#"+formId+" .errorMsg").slideDown();

	if(extras.dont_scroll_on_error != '1')
	{
		if(extras.scrollto != undefined)
   		{
   			if($('#fbcontent').length > 0) {
        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
        	} else {
        		//$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
        	}
   		}
   		else
   		{
   			if($('#fbcontent').length > 0) {
        		$('#fancybox-inner').scrollTo(0,100);
        	} else {
        		//$.scrollTo(0,800);
        	}
   		}
	}

	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
}

/*extras parameters:
	clearErrors = if 0, errors will NOT be cleared.  default will clear
*/
function showUploadErrors(data,uploadHolderId,errorElemID,extras)
{
	if(extras.clearErrors != 0) { removeUploadErrors(uploadHolderId); }

	$(".fileupload").addClass("error");

	var newData = new Object();
	if(data[0]==undefined) newData = data;
	else newData = data[0];

	if(newData[uploadHolderId] != "") {
		$("#"+uploadHolderId+errorElemID).addClass("uploadifyError");
		$('label[for='+uploadHolderId+']').addClass("error");

		if(newData[uploadHolderId] != 1) {
			$("#"+uploadHolderId+"Error").html($("#"+uploadHolderId+"Error").html()+'<li>'+newData[uploadHolderId]+'</li>');
		}
	}
	if($("#"+uploadHolderId+"Error").html()=="") {
		$("#"+uploadHolderId+"Error").html("<li>We experienced an error when uploading the file(s) in highlighted in red above</li>");
	}
	$("#"+uploadHolderId+"Error").slideDown();
}

function removeUploadErrors(uploadHolderId)
{
	$("#"+uploadHolderId+"Queue").each(function(){
		$(this).removeClass(uploadHolderId+"uploadifyError");
	});
	$('label[for='+uploadHolderId+']').removeClass("error");
	$("#"+uploadHolderId+"Error").html('');
	$("#"+uploadHolderId+"Error").slideUp();
}

function clearErrors(formId)  //safari bug is here!!
{
	$('input[type="text"],input[type="password"],textarea,select').removeClass("error");
	$('#'+formId+' label').each(function(index){
        if(!$(this).hasClass('errorMsg')) $(this).removeClass("error");
    });
	$('.customMsg').html("");
	$('.customMsg').hide();
}

function resetForm(formId)
{
	//$('[type="text"]').val("");
	$('#'+formId+' textarea').val("");
	$(':input','#'+formId)
	 .not(':button, :submit, :reset, :hidden, :checkbox , :radio')
	 .val('')
	 .removeAttr('checked')
	 .removeAttr('selected');

	clearErrors(formId);
}

function getGroupCheckBoxValues(nameValue,numValues)
{
	var i=0;
	var checked = 0;
	var values = '['
    $('input[name="'+nameValue+'[]"]').each(function(){
		if(i != 0) { values += ','; }
		if($("#"+this.id).attr('checked')) { checked = 1; } else { checked = 0; }
		values += '{"'+nameValue+'":"'+checked+'"}';
		i++;
    });
    if(values.charAt(values.length)==",") values.slice(0, -1);
    values += "]";
    return values;
}

function getGroupInputValues(nameValue,numValues)
{
	var i=0;
	var values = '['
    $('input[name="'+nameValue+'[]"]').each(function(){
		if(i != 0) { values += ','; }
		values += '{"'+nameValue+'":"'+$("#"+this.id).val()+'"}';
		i++;
    });
    if(values.charAt(values.length)==",") values.slice(0, -1);
    values += "]";
    return values;
}

/* Populate a field with a suggested SEO name
 * title: name to base return value off of
 * field_name: form field to write seo name to
 * override: if false only write to the field if it is empty, if true always write to the field no matter what the current value is
 */
function suggestSeoName(title,field_name,override)
{
	if(override == undefined) { override = false; }
	if((override || $('#'+field_name).val() == "") && title != "")
	{
		seoName = removeMSWordChars($.trim(title));
		seoName = seoName.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/ /g,'-').replace(/[^\w-]+/g,'');

		$('#'+field_name).val(seoName.toLowerCase());
	}
}

function removeMSWordChars(str)
{
	var myReplacements = new Array();
	var myCode, intReplacement;
	myReplacements[8216] = 39;
	myReplacements[8217] = 39;
	myReplacements[8220] = 34;
	myReplacements[8221] = 34;
	myReplacements[8212] = 45;
	for(c=0; c<str.length; c++) {
		var myCode = str.charCodeAt(c);
		if(myReplacements[myCode] != undefined) {
			intReplacement = myReplacements[myCode];
			str = str.substr(0,c) + String.fromCharCode(intReplacement) + str.substr(c+1);
		}
	}
	return str;
}

/* This will countdown the number of characters remaining and put the result in a field called fieldID+'_chars'
*/
function getCharsRemaining(fieldID,numChars)
{
	var charcount = (parseInt(numChars)-$('#'+fieldID).val().length);
	if(charcount <= 0) { $('#'+fieldID).val($('#'+fieldID).val().substring(0, numChars)); }
	$('#'+fieldID+'_chars').html(charcount);
}

function isset(var_to_check)
{
	if (typeof var_to_check != 'undefined') {
  		return true;
	}
	else return false;
}

function limitCheckbox(checkboxname, limit)
{
	numChecked=0;
	$('input[name='+checkboxname+']').each(function() {
		if (this.checked)
		{
			numChecked++;
            if(numChecked>3)
            {
            	alert("You can select a maximum of "+limit+" checkboxes");
            	this.checked=false;
            }
        }
	});
}
function allInputsToObjectAdmin(form_id, options, additional_non_input_values)
{

    /*
        OPTIONS:
            nest_input_by_name : if set will nest all inputs by their name. independent of nest_checkboxes_by_name and nest_radiobuttons_by_name. still need to set the opt for radio and checkboxes. this will only work for inputs, selects and textareas

            nest_checkboxes_by_name : if set it will nest all the cehckboxes like data[name][id] = true/false
            use_checkbox_value_if_true : if set will use the check boxes value instead of true. can be used with the nest option. value/false
            leave_out_falses : if set will leave out the falsest from the obj

            nest_radiobuttons_by_name : if set it will nest all the radiobuttons like data[name][id] = true/false
    */
    // not sure if you wanted this, but I thought I'd add it.
    // get an associative array of just the values.
    var values = {};

    //add the additional non input values to the value object
    $.each(additional_non_input_values, function(index,val){

        if(typeof(val)=='object'){values[index]=val;} //if its an object just set the obj as the value, otherwise it will typecast and lost the obj and instead set it as [object Array]
        else
        {
            values[index] = String(val); //typecast because js will see it as an array of characters if not typecasted
        }
    });


    // get all the inputs into an array.
    var $inputs = $('#'+form_id+' input, #'+form_id+' textarea, #'+form_id+' select  ');



    $inputs.each(function()
    {
        if(this.type=="checkbox")
        {
            if(options.nest_checkboxes_by_name == true && this.name != '')
            {
                if(typeof values[this.name] == 'undefined'){ values[this.name]={} } //check if the array has been initialized, if not then initialize it

                if(options.use_checkbox_value_if_true && $('#'+this.id).is(':checked')) //if option set AND the checkbox is checked use its value
                {
                    values[this.name][this.id] = this.value;
                }
                else
                {
                    if(options.leave_out_falses==true && $('#'+this.id).is(':checked')==false){ return 'continue'; } //leave out the falses and this checkbox is false, continue to next without saving to our obj

                    values[this.name][this.id] = $('#'+this.id).is(':checked');
                }
            }
            else
            {
                if(options.use_checkbox_value_if_true && $('#'+this.id).is(':checked')) //if option set AND the checkbox is checked use its value
                {
                    values[this.id] = this.value;
                }
                else
                {
                    if(options.leave_out_falses==true && $('#'+this.id).is(':checked')==false){ return 'continue'; } //leave out the falses and this checkbox is false, continue to next without saving to our obj

                    values[this.id] = $('#'+this.id).is(':checked');
                }

            }
        }
        //KATIE ADDED RADIO BUTTONS BECAUSE DAVID MESSED UP AND FORGOT ABOUT THEM
        else if(this.type=="radio")
        {
            if(options.nest_radiobuttons_by_name == true && this.name != '')
            {
                if(typeof values[this.name] == 'undefined'){ values[this.name]={} } //check if the array has been initialized, if not then initialize it
                values[this.name][this.id] = $('#'+this.id).is(':checked');
            }
            else
            {
                values[this.id] = $('#'+this.id).is(':checked');
            }
        }
 
        else
        {
            if(options.nest_input_by_name==true && this.name!='')
            {
                if(typeof values[this.name] == 'undefined'){ values[this.name]={} } //check if the array has been initialized, if not then initialize it
                values[this.name][this.id] = $(this).val();
            }
            else
            {
                values[this.id] = $(this).val();
            }
        }
    });



    return values;
}
function allInputsToObject(form_id, options, additional_non_input_values)
{
	/*
		OPTIONS:
			nest_input_by_name : if set will nest all inputs by their name. independent of nest_checkboxes_by_name and nest_radiobuttons_by_name. still need to set the opt for radio and checkboxes. this will only work for inputs, selects and textareas

			nest_checkboxes_by_name : if set it will nest all the cehckboxes like data[name][id] = true/false
			use_checkbox_value_if_true : if set will use the check boxes value instead of true. can be used with the nest option. value/false
			leave_out_falses : if set will leave out the falsest from the obj

			nest_radiobuttons_by_name : if set it will nest all the radiobuttons like data[name][id] = true/false
	*/
    var values = {}; 


    //add the additional non input values to the value object
    $.each(additional_non_input_values, function(index,val){

		if(typeof(val)=='object'){values[index]=val;} //if its an object just set the obj as the value, otherwise it will typecast and lost the obj and instead set it as [object Array]
		else
		{
			values[index] = String(val); //typecast because js will see it as an array of characters if not typecasted
		}
	});

	// get all the inputs into an array.
    var $inputs = $('#'+form_id+' input[id], #'+form_id+' textarea[id], #'+form_id+' select[id]');


    $inputs.each(function()
    {
    	if(this.type=="checkbox")
    	{
    		if(options.nest_checkboxes_by_name == true && this.name != '')
    		{
    			if(typeof values[this.name] == 'undefined'){ values[this.name]={} } //check if the array has been initialized, if not then initialize it

    			if(options.use_checkbox_value_if_true && $('#'+this.id).is(':checked')) //if option set AND the checkbox is checked use its value
    			{
    				values[this.name][this.id] = this.value;
    			}
    			else
    			{
    				if(options.leave_out_falses==true && $('#'+this.id).is(':checked')==false){ return 'continue'; } //leave out the falses and this checkbox is false, continue to next without saving to our obj

    				values[this.name][this.id] = $('#'+this.id).is(':checked');
    			}
    		}
    		else
    		{
    		   	if(options.use_checkbox_value_if_true && $('#'+this.id).is(':checked')) //if option set AND the checkbox is checked use its value
    			{
    				values[this.id] = this.value;
    			}
    			else
    			{
    				if(options.leave_out_falses==true && $('#'+this.id).is(':checked')==false){ return 'continue'; } //leave out the falses and this checkbox is false, continue to next without saving to our obj

    				values[this.id] = $('#'+this.id).is(':checked');
    			}

    		}
    	}
    	else if(this.type=="radio")
    	{
    		if(options.nest_radiobuttons_by_name == true && this.name != '')
    		{
    			if(typeof values[this.name] == 'undefined'){ values[this.name]={} } //check if the array has been initialized, if not then initialize it
    			values[this.name][this.id] = $('#'+this.id).is(':checked');
    		}
    		else
    		{
    			values[this.id] = $('#'+this.id).is(':checked');
    		}
    	}

    	else
    	{
    		if(options.nest_input_by_name==true && this.name!='')
    		{
    			if(typeof values[this.name] == 'undefined'){ values[this.name]={} } //check if the array has been initialized, if not then initialize it
    			values[this.name][this.id] = $(this).val();
       		}
    		else
    		{
        		values[this.id] = $(this).val();
    		}
    	}
    });



    return values;
}



function mysqlToDate(mysqldate){
	var t = mysqldate.split(/[- :]/);

	// Apply each element to the Date function
	var d = new Date(t[0], t[1]-1, t[2], t[3], t[4], t[5]);
	return d;
}

function getSizeOfjsObj(obj) //do like this so its compatible with ie8
{

	var count = 0;
	for (i in obj) {
   		if (obj.hasOwnProperty(i)) {
        	count++;
	    }
	}
	return count;
}

//use like str_replace from php…. use like 'okay.this.is.a.string'.replaceAll('.', ' ');
String.prototype.replaceAll = function( token, newToken, ignoreCase ) {
    var _token;
    var str = this + "";
    var i = -1;

    if ( typeof token === "string" ) {

        if ( ignoreCase ) {

            _token = token.toLowerCase();

            while( (
                i = str.toLowerCase().indexOf(
                    token, i >= 0 ? i + newToken.length : 0
                ) ) !== -1
            ) {
                str = str.substring( 0, i ) +
                    newToken +
                    str.substring( i + token.length );
            }

        } else {
            return this.split( token ).join( newToken );
        }

    }
return str;
};


function getRandomNumber(range)
{
	return Math.floor(Math.random() * range);
}

function getRandomChar()
{
	var chars = "0123456789abcdefghijklmnopqurstuvwxyzABCDEFGHIJKLMNOPQURSTUVWXYZ";
	return chars.substr( getRandomNumber(62), 1 );
}

function randomID(size)
{
	var str = "";
	for(var i = 0; i < size; i++)
	{
		str += getRandomChar();
	}
	return str;
}

function endPreview(){
	$.ajax({
		url : FRONTEND_ROOT+'ajax/site_preview.php',
		dataType : 'json',
		data : { operation : 'endPreview'},
		success : function(){
			close();
		}
	});
}
